import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Checkbox } from '@node-space/ui-components'
import { BeneficiaryType } from 'types/beneficiaries'

type BeneficaryTypeCheckboxProps = {
  isFirstPartyBeneficiary: boolean
  disabled: boolean
  setValue: (name: string, beneficaryType: string) => void
}

export const BeneficaryTypeCheckbox = ({
  isFirstPartyBeneficiary,
  disabled,
  setValue,
}: BeneficaryTypeCheckboxProps) => {
  const { t } = useTranslation()
  return (
    <Box paddingT={8}>
      <Checkbox
        id="beneficiary-type"
        checked={isFirstPartyBeneficiary}
        onCheckedChange={value =>
          setValue(
            'beneficiaryType',
            value ? BeneficiaryType.FIRST_PARTY : BeneficiaryType.THIRD_PARTY
          )
        }
        label={t('manageBeneficiaries.beneficiaryTypeSelection')}
        disabled={disabled}
        name="checkbox"
        testId="beneficiary-type"
      />
    </Box>
  )
}
